import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './NotFound.css';

function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();
  const [countdown, setCountdown] = useState(5);
  const timerRef = useRef(null);
  const triedBackRef = useRef(false);

  const handleRedirect = () => {
    // Clear the timer if it exists
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    // Redirect based on auth status
    if (currentUser) {
      // If there is history to go back to within the app, try going back
      const canGoBackInApp = typeof window !== 'undefined'
        && window.history
        && window.history.state
        && typeof window.history.state.idx === 'number'
        && window.history.state.idx > 0;

      if (canGoBackInApp) {
        triedBackRef.current = true;
        navigate(-1);
        return;
      }
    }
    // If not logged in or cannot go back, send to root
    navigate('/', { replace: true });
  };

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          // Use the same redirect logic as the button
          handleRedirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [navigate, currentUser]);

  // If we tried to go back but still landed on a not-found route, fall back to root
  useEffect(() => {
    if (triedBackRef.current) {
      triedBackRef.current = false;
      navigate('/', { replace: true });
    }
  }, [location.key, navigate]);

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <p className="not-found-message">Page Not Found</p>
        <p className="not-found-redirect">
          Redirecting in {countdown} second{countdown !== 1 ? 's' : ''}...
        </p>
        <button className="not-found-button" onClick={handleRedirect}>
          Go back now
        </button>
      </div>
    </div>
  );
}

export default NotFound;

